//import { addToolState } from "../../stateManagement/toolState.js";
import { addToolState } from "component/toolManager/toolState.js";
import { moveHandle, moveNewHandle } from "../manipulators/index.js";

export default function(evt, tool) {
  //
  evt.preventDefault();
  evt.stopPropagation();
  const eventData = evt.detail;
  const element = eventData.element;
  const measurementData = tool.createNewMeasurement(eventData);

  if (!measurementData) {
    return;
  }

  // Associate this data with this imageId so we can render it and manipulate it
  addToolState(element.element, tool.name, measurementData);

  // update
  const handleMover =
    Object.keys(measurementData.handles).length === 1
      ? moveHandle
      : moveNewHandle;

  handleMover(
    eventData,
    //element.element,
    tool.name,
    measurementData,
    measurementData.handles.end,
    tool.options,
    "mouse"
  );
}
